<div class="project-onboarding-page">
  <div class="hero">
    <div>
      <p class="eyebrow">Onboarding</p>
      <h2>Requirements Intake</h2>
      <p class="sub">Upload project requirement PDF, review, and acknowledge correctness.</p>
    </div>
    <button mat-stroked-button color="primary" (click)="loadOnboarding()">
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
  </div>

  <div class="controls">
    <mat-form-field appearance="outline" class="project-select">
      <mat-label>Project</mat-label>
      <mat-select [(value)]="selectedProjectId" (selectionChange)="loadOnboarding()">
        <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="grid">
    <section class="panel form-panel">
      <div class="panel-head">
        <div>
          <p class="eyebrow">{{ selectedItem ? 'Editing' : 'Create' }}</p>
          <h3>{{ selectedItem ? selectedItem.title : 'New Requirement' }}</h3>
        </div>
        <span class="chip muted">PDF required</span>
      </div>

      <div class="form-grid">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Requirement Title</mat-label>
          <input matInput [(ngModel)]="form.title" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Project Description</mat-label>
          <textarea matInput rows="4" [(ngModel)]="form.description"></textarea>
        </mat-form-field>

        <div class="upload-field full-width">
          <label>Requirement Document (PDF only)</label>
          <input type="file" accept="application/pdf" (change)="onFileSelected($event)" />
          <p class="hint">Upload the current requirement document. To change it later, upload a new PDF and mark it as current.</p>
        </div>

        <div class="preview full-width" *ngIf="form.attachmentUrl">
          <div class="preview-head">
            <span>{{ form.attachmentName || 'Requirement.pdf' }}</span>
            <span class="chip">PDF</span>
          </div>
          <object [data]="form.attachmentUrl" type="application/pdf" width="100%" height="320"></object>
        </div>

        <mat-checkbox class="full-width" [(ngModel)]="acknowledge">
          I confirm this is the correct requirement document for this project.
        </mat-checkbox>
      </div>

      <div class="actions">
        <button mat-stroked-button (click)="resetForm()">Clear</button>
        <button mat-flat-button color="primary" (click)="save()" [disabled]="saving || !canManageOnboarding()">
          {{ saving ? 'Saving...' : 'Save Requirement' }}
        </button>
      </div>
    </section>

    <section class="panel table-panel">
      <div class="panel-head">
        <div>
          <p class="eyebrow">History</p>
          <h3>Onboarding Records</h3>
        </div>
        <span class="chip muted">{{ rows.length }} records</span>
      </div>

      <table mat-table [dataSource]="rows" class="full-table mat-elevation-z1">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let row">{{ row.title }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">{{ row.status }}</td>
        </ng-container>

        <ng-container matColumnDef="uploadedByName">
          <th mat-header-cell *matHeaderCellDef>By</th>
          <td mat-cell *matCellDef="let row">{{ row.uploadedByName || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="uploadedAt">
          <th mat-header-cell *matHeaderCellDef>Uploaded</th>
          <td mat-cell *matCellDef="let row">{{ row.uploadedAt | date:'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="attachment">
          <th mat-header-cell *matHeaderCellDef>Document</th>
          <td mat-cell *matCellDef="let row">
            <a *ngIf="row.attachmentUrl" [href]="row.attachmentUrl" target="_blank" rel="noopener">View PDF</a>
            <span *ngIf="!row.attachmentUrl">-</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button (click)="editItem(row)" [disabled]="!canManageOnboarding()">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['title','status','uploadedByName','uploadedAt','attachment','actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['title','status','uploadedByName','uploadedAt','attachment','actions'];"></tr>
      </table>
    </section>
  </div>
</div>
